// extracted by mini-css-extract-plugin
export var shake = "_a-0";